import {
  collection,
  getDocs,
  query,
  limit,
  startAfter,
  QueryDocumentSnapshot,
  DocumentData,
  orderBy,
  getCountFromServer,
  where,
} from 'firebase/firestore';
import Failure from '../../../core/Failure';
import { FirestoreCollections, firestore } from '../../../firebase.config';
import { ICompany } from '@leedpulse-monorepo/interfaces';

async function getCompanies(
  offset: number,
  lastVisible?: QueryDocumentSnapshot<DocumentData, DocumentData>,
  filterWithCompanyIds?: string[]
): Promise<{
  companies: ICompany[];
  lastVisible: QueryDocumentSnapshot<DocumentData, DocumentData>;
  totalCollectionCount: number;
}> {
  try {
    const db = firestore;
    const companiesCollection = collection(
      db,
      FirestoreCollections.companies
    );

    const results = lastVisible
      ? await getDocs(
          filterWithCompanyIds
            ? query(
                companiesCollection,
                where('id', 'in', filterWithCompanyIds),
                orderBy('created', 'desc'),
                startAfter(lastVisible),
                limit(offset)
              )
            : query(
                companiesCollection,
                orderBy('created', 'desc'),
                startAfter(lastVisible),
                limit(offset)
              )
        )
      : filterWithCompanyIds
      ? await getDocs(
          query(
            companiesCollection,
            where('id', 'in', filterWithCompanyIds),
            orderBy('created', 'desc'),
            limit(offset)
          )
        )
      : await getDocs(
          query(
            companiesCollection,
            orderBy('created', 'desc'),
            limit(offset)
          )
        );

    const companies: ICompany[] = [];

    results.docs.forEach((doc) => {
      companies.push(doc.data() as ICompany);
    });

    const companiesSnapshot = filterWithCompanyIds
      ? await getCountFromServer(
          query(
            companiesCollection,
            where('id', 'in', filterWithCompanyIds)
          )
        )
      : await getCountFromServer(companiesCollection);

    return {
      companies,
      lastVisible: results.docs[results.docs.length - 1] ?? {},
      totalCollectionCount: companiesSnapshot.data().count ?? 0,
    };
  } catch (e) {
    console.log('error: ', e);
    throw new GetCompaniesFailure();
  }
}

export class GetCompaniesFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default getCompanies;
